"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { atoms } from "@gnist/themes/atoms.css.js";
import * as React from "react";
const formContext = React.createContext(void 0);
const Form = ({ onSubmit, submitOnEnter, children, ...rest }) => jsx("form", { onSubmit: (event) => {
  event.preventDefault();
  onSubmit == null ? void 0 : onSubmit();
}, ...rest, children: jsx("div", { role: "presentation", onKeyDown: (event) => {
  if (event.key === "Enter" && !submitOnEnter) {
    event.preventDefault();
  }
}, children }) });
function FormProvider({ id, form, onSubmit, hideNecessityText = false, submitOnEnter = false, children, ...rest }) {
  return jsxs(formContext.Provider, { value: { id, form }, children: [!hideNecessityText && jsx("p", { className: atoms({ marginBottom: "m" }), children: form.necessityText }), jsx(Form, { onSubmit: () => {
    if (form.state.isValid) {
      onSubmit == null ? void 0 : onSubmit(form.state.validated);
      return;
    }
    form.showAllErrors();
  }, submitOnEnter, ...rest, children })] });
}
function useForm() {
  return React.useContext(formContext);
}
export {
  FormProvider,
  useForm
};
